import { identity } from 'rxjs';
import { createElementFocusService } from '../../services/dom/elementFocusService';
import { createAutocompleteService } from '../../services/text/autocompleteService';
import { createSimpleCommitService } from '../../services/text/commitService';
import { createInputSelectionService } from '../../services/text/inputSelectionService';
import { createInputTextService } from '../../services/text/inputTextService';
import { createInputTextUnderCursorService } from '../../services/text/inputTextUnderCursorService';
import { NULL_TEXT_EDIT_SERVICE } from '../../services/text/textEditService';
import { createTextEmptyService } from '../../services/text/textEmptyService';
import { ConnectingEditor, createConnectingEditor } from '../base/connectingEditor';
import { EditorSpec } from '../base/editor';
import { TextEditorServices } from './textEditor';

type InputElement = HTMLTextAreaElement | HTMLInputElement;

export type InputTextEditor<S extends TextEditorServices = TextEditorServices> = ConnectingEditor<
  InputElement,
  S
>;

type InputTextEditorMapSpec<S extends TextEditorServices> = (
  spec: EditorSpec<TextEditorServices>,
) => EditorSpec<S>;

export function createInputTextEditor<S extends TextEditorServices>(
  mapSpec: InputTextEditorMapSpec<S>,
): InputTextEditor<S>;
export function createInputTextEditor(): InputTextEditor;
export function createInputTextEditor<S extends TextEditorServices>(
  mapSpec: InputTextEditorMapSpec<S> = identity as InputTextEditorMapSpec<S>,
): InputTextEditor<S> {
  return createConnectingEditor(element$ => {
    const textService = createInputTextService(element$);
    const textUnderCursor = createInputTextUnderCursorService(element$);

    return mapSpec({
      services: {
        commit: createSimpleCommitService(),
        focus: createElementFocusService(element$),
        selection: createInputSelectionService(element$),
        text: textService,
        empty: createTextEmptyService(textService),
        textUnderCursor,
        // TODO
        edit: NULL_TEXT_EDIT_SERVICE,
        autocomplete: createAutocompleteService(textUnderCursor),
      },
    });
  });
}
